<footer class="
  content-horizontal-right
  content-vertical-center
">
    <div style="display:flex;width: 640px;margin:auto">
        <slot/>
    </div>
</footer>

<style>
	footer {
		justify-content: flex-end;
		align-items: center;
		text-align: center;
		display: flex;
		min-height: 8vh;
		padding: 24px;
	    border-top: 1px solid #efefef;
        background-color: #f8f8f8;
	}
</style>